import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {QuoteConstants} from '../../../quotes/model/quote';
import {Product, ProductContainer} from '../../models/product';
import { StoreService } from 'src/app/core/services/store.service';

@Component({
    selector: 'app-product-card',
    templateUrl: './product-card.component.html',
    styleUrls: ['./product-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductCardComponent {

    @Output()
    view = new EventEmitter<Product>();
    @Output()
    addToQuote = new EventEmitter<Product>();
    @Input()
    productContainer: ProductContainer;

    readonly decorDefaultName = QuoteConstants.DECOR_DEFAULT_NAME;

    constructor(public storeService: StoreService) {
        
    }

    get product(): Product {
        if (this.productContainer) {
            return this.productContainer.product;
        } else {
            return null;
        }
    }

    get isLoading(): boolean {
        if (this.productContainer) {
            return this.productContainer.isLoading;
        } else {
            return true;
        }
    }

    get hasThumbnail(): boolean {
        return this.product != null && this.product.thumbnailUrl != null && this.product.thumbnailUrl.length > 0;
    }

    triggerView() {
        this.view.emit(this.product);
    }

    triggerAddToQuote() {
        this.addToQuote.emit(this.product);
    }

}
